export default theme => {
  return {
    container: {
      padding: 5
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Tmobile/theme/components/scorecard/ScorecardView/ScorecardHeader.js